module.exports = __webpack_public_path__ + "static/media/inoltrato.e3035ee4.svg";